import * as React from 'react';
import { SVGProps } from 'react';

const FileIconGifSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 34 40" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M32 0H2a2 2 0 0 0-2 2v36a2 2 0 0 0 2 2h30a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2Z" />
    <path
      opacity={0.6}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.5 18H9v9.667L12 25l6 5 4-3 3 2.25V18H9.5ZM9 31.5v-2.167l3-2.81 5.906 4.797L22 28.25l3 2.25V32H9v-.5Zm-1-13V33h18V17H8v1.5Zm10 4a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Zm1.5-2.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5Z"
      fill="#fff"
    />
    <path
      d="M18 6V5h-1v1h1ZM16 7v1h1v3h-1v1h3v-1h-1V7h-2ZM22.35 6a.374.374 0 0 0-.26.09.268.268 0 0 0-.09.21V7h1v1h-1v3h1v1h-3v-1h1V8h-1V7h1v-.9c0-.34.097-.607.29-.8.193-.2.443-.3.75-.3h1.46v1h-1.15Z"
      fill="#fff"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14 11.8c-.207.133-.457.2-.75.2h-.55c-.587 0-1.017-.123-1.29-.37-.273-.253-.41-.663-.41-1.23V8.6c0-.56.137-.967.41-1.22.28-.253.71-.38 1.29-.38H15v6a1 1 0 0 1-1 1h-2.5v-1H13c.84 0 1 0 1-1v-.2Zm-.65-.8c.22 0 .383-.057.49-.17a.565.565 0 0 0 .16-.38V8h-1.25c-.247 0-.433.057-.56.17-.127.113-.19.273-.19.48v1.7c0 .207.063.367.19.48.127.113.313.17.56.17h.6Z"
      fill="#fff"
    />
  </svg>
);
export default FileIconGifSizeM;
